import Avatar from './Avatar';
export { default as AvatarLetter } from './AvatarLetter';

export default Avatar;
